export const articleCategories = [
  {
    slug: 'short-video',
    name: '短视频制作',
    description: '专业短视频策划、拍摄与后期制作，打造高传播性品牌内容',
    icon: 'ri-video-line',
  },
  {
    slug: 'social-media',
    name: '社交媒体运营',
    description: '多平台社交媒体账号运营，精准触达目标用户群体',
    icon: 'ri-share-line',
  },
  {
    slug: 'ad-planning',
    name: '广告策划',
    description: '创意广告策略与执行，实现品牌高效曝光与转化',
    icon: 'ri-lightbulb-line',
  },
  {
    slug: 'full-case',
    name: '全案营销',
    description: '从策略到执行的一站式整合营销解决方案',
    icon: 'ri-stack-line',
  },
  {
    slug: 'content-creative',
    name: '内容创意',
    description: '原创内容创意策划，赋予品牌独特表达力',
    icon: 'ri-quill-pen-line',
  },
];

export const allArticles = [
  {
    id: 1,
    title: '如何通过短视频打造品牌记忆点',
    slug: 'how-to-build-brand-memory-with-short-video',
    category: 'short-video',
    categoryName: '短视频制作',
    excerpt: '在碎片化阅读时代，短视频已成为品牌触达用户的最有效方式之一。果冻传媒总结了一套系统化的短视频品牌建设方法论，帮助品牌在15秒内建立深刻记忆。',
    content: `<p>在碎片化阅读时代，短视频已成为品牌触达用户的最有效方式之一。果冻传媒总结了一套系统化的短视频品牌建设方法论，帮助品牌在15秒内建立深刻记忆。</p>
<h2>为什么短视频是品牌传播的最佳载体</h2>
<p>根据最新数据，中国短视频用户规模已突破10亿，人均日使用时长超过2小时。这意味着品牌如果不布局短视频赛道，将错失与海量用户建立连接的机会。</p>
<p>短视频具备三大核心优势：传播速度快、用户参与度高、内容形式灵活。相比传统图文内容，短视频能够更直观地传递品牌情感与价值观。</p>
<h2>果冻传媒的短视频创作方法论</h2>
<p>我们通过"三秒定律"抓住用户注意力：前3秒设置悬念或冲突，中段展开核心内容，结尾设置行动引导。整个视频围绕一个核心信息点展开，避免贪多嚼不烂。</p>
<p>在技术层面，我们注重光影质感和声音设计，让每一帧画面都具有视觉冲击力，让品牌质感自然流露。</p>
<h2>实战案例分享</h2>
<p>某美妆品牌通过果冻传媒策划的系列短视频，在抖音平台获得累计5000万+播放量，粉丝增长300%，直接带动线上销售增长120%。</p>
<p>成功的关键在于：精准的用户画像、差异化的内容定位、持续优化的数据反馈机制。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20video%20production%20studio%20with%20warm%20cinematic%20lighting%2C%20creative%20team%20working%20on%20video%20editing%2C%20modern%20minimalist%20workspace%2C%20soft%20warm%20tones%2C%20editorial%20photography%20style%2C%20clean%20composition%20with%20professional%20camera%20equipment%20and%20storyboard%20on%20wall&width=800&height=500&seq=article-cover-01&orientation=landscape',
    author: '张明远',
    authorTitle: '创意总监',
    publishedAt: '2026-07-28',
    readTime: '8分钟',
    tags: ['短视频', '品牌营销', '内容策略'],
  },
  {
    id: 2,
    title: '社交媒体运营的五个黄金法则',
    slug: 'five-golden-rules-of-social-media-operation',
    category: 'social-media',
    categoryName: '社交媒体运营',
    excerpt: '社交媒体运营不是简单的发帖和回复，而是一门深度的用户关系经营学问。果冻传媒基于多年实战经验，提炼出五大黄金法则。',
    content: `<p>社交媒体运营不是简单的发帖和回复，而是一门深度的用户关系经营学问。果冻传媒基于多年实战经验，提炼出五大黄金法则。</p>
<h2>法则一：内容为王，质量为上</h2>
<p>优质内容始终是社交媒体运营的根基。每条内容都应该围绕用户需求展开，提供真正的价值——无论是知识、娱乐还是情感共鸣。</p>
<h2>法则二：互动是灵魂</h2>
<p>品牌不能只是单向输出，必须建立双向沟通机制。果冻传媒建议品牌在发布内容后的2小时内，安排专人与用户互动，回复率达到95%以上。</p>
<h2>法则三：数据驱动决策</h2>
<p>我们建立了完善的数据分析体系，通过用户互动数据、内容传播数据和转化漏斗数据，持续优化运营策略。</p>
<h2>法则四：平台差异化运营</h2>
<p>微信生态侧重私域沉淀，微博侧重话题引爆，小红书侧重种草转化，抖音侧重娱乐传播——不同平台需要不同的内容策略和运营节奏。</p>
<h2>法则五：长期主义心态</h2>
<p>社交媒体运营是一场持久战，品牌需要有耐心。我们建议以季度为周期评估运营效果，避免过度关注短期数据波动。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20social%20media%20command%20center%20with%20multiple%20screens%20displaying%20analytics%20dashboards%20and%20content%20calendars%2C%20warm%20ambient%20lighting%2C%20professional%20team%20collaborating%2C%20clean%20minimal%20design%20aesthetic%2C%20subtle%20warm%20color%20palette%20with%20organic%20textures&width=800&height=500&seq=article-cover-02&orientation=landscape',
    author: '李思涵',
    authorTitle: '运营总监',
    publishedAt: '2026-07-25',
    readTime: '6分钟',
    tags: ['社交媒体', '运营策略', '用户增长'],
  },
  {
    id: 3,
    title: '广告策划：从洞察到创意落地的全流程',
    slug: 'ad-planning-from-insight-to-creative-execution',
    category: 'ad-planning',
    categoryName: '广告策划',
    excerpt: '一条成功的广告背后，是严谨的策略推导和出色的创意执行。果冻传媒分享广告策划的全流程方法论。',
    content: `<p>一条成功的广告背后，是严谨的策略推导和出色的创意执行。果冻传媒分享广告策划的全流程方法论。</p>
<h2>洞察阶段：理解消费者真实需求</h2>
<p>广告策划的起点永远是消费者洞察。我们通过定量调研和定性访谈相结合的方式，深入理解目标受众的痛点、欲望和决策逻辑。</p>
<h2>策略阶段：找到品牌的独特定位</h2>
<p>基于洞察结果，我们为品牌制定差异化的传播策略。核心是回答三个问题：对谁说？说什么？为什么相信？</p>
<h2>创意阶段：让策略变得有趣</h2>
<p>果冻传媒的创意团队擅长将策略转化为令人过目不忘的视觉语言和文案表达。我们坚信：好的创意应该是策略的自然延伸，而非天马行空的炫技。</p>
<h2>执行阶段：细节决定成败</h2>
<p>从分镜脚本到实地拍摄，从后期制作到媒介投放，我们实行全流程品控，确保创意不打折扣地呈现在消费者面前。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Creative%20advertising%20agency%20brainstorming%20session%20with%20mood%20boards%20and%20sketches%20on%20wall%2C%20natural%20light%20streaming%20through%20large%20windows%2C%20professional%20creative%20team%20around%20wooden%20table%2C%20warm%20inspiring%20atmosphere%2C%20editorial%20photography%2C%20soft%20tones%20with%20artistic%20composition&width=800&height=500&seq=article-cover-03&orientation=landscape',
    author: '王浩然',
    authorTitle: '策略总监',
    publishedAt: '2026-07-20',
    readTime: '10分钟',
    tags: ['广告策划', '创意策略', '品牌传播'],
  },
  {
    id: 4,
    title: '全案营销：品牌增长的系统化解决方案',
    slug: 'full-case-marketing-systematic-brand-growth',
    category: 'full-case',
    categoryName: '全案营销',
    excerpt: '单点突破的时代已经过去，品牌需要的是一套系统化的整合营销方案。果冻传媒全案营销服务助力品牌实现可持续增长。',
    content: `<p>单点突破的时代已经过去，品牌需要的是一套系统化的整合营销方案。果冻传媒全案营销服务助力品牌实现可持续增长。</p>
<h2>什么是全案营销</h2>
<p>全案营销并非简单地将各种营销手段拼凑在一起，而是围绕品牌战略目标，整合线上线下的各种传播资源和销售渠道，形成协同效应。</p>
<h2>果冻传媒的全案服务模型</h2>
<p>我们独创"品牌诊断-策略规划-创意执行-效果追踪"四步模型，确保每一项营销投入都能产生可量化的回报。</p>
<h2>案例：某新锐消费品牌的全案运营</h2>
<p>从品牌定位梳理到视觉体系搭建，从社交媒体矩阵到电商渠道布局，果冻传媒为某新锐消费品牌提供了为期12个月的全案服务，帮助其实现从0到年营收过亿的跨越式增长。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Integrated%20marketing%20strategy%20visualization%20with%20interconnected%20network%20diagram%20on%20whiteboard%2C%20modern%20office%20with%20warm%20lighting%2C%20professional%20business%20presentation%20setup%2C%20clean%20minimal%20aesthetic%2C%20soft%20natural%20light%2C%20creative%20yet%20corporate%20atmosphere&width=800&height=500&seq=article-cover-04&orientation=landscape',
    author: '赵雨晴',
    authorTitle: '客户总监',
    publishedAt: '2026-07-15',
    readTime: '7分钟',
    tags: ['全案营销', '品牌增长', '整合营销'],
  },
  {
    id: 5,
    title: '内容创意的底层逻辑与实战技巧',
    slug: 'content-creativity-fundamental-logic-and-skills',
    category: 'content-creative',
    categoryName: '内容创意',
    excerpt: '好的内容创意不是碰运气，而是有一套可复用的方法论。果冻传媒创意团队首次公开我们的内容创意心法。',
    content: `<p>好的内容创意不是碰运气，而是有一套可复用的方法论。果冻传媒创意团队首次公开我们的内容创意心法。</p>
<h2>创意的本质是连接</h2>
<p>最打动人心的创意，往往来自于将看似无关的元素建立出人意料的连接。果冻传媒鼓励创意团队跨领域阅读和学习，积累丰富的"连接素材库"。</p>
<h2>内容创意的三个检验标准</h2>
<p>我们内部评审创意时，使用三个标准：是否有记忆点？是否引发情感共鸣？是否驱动行动？三条全满足的创意，才有资格进入执行阶段。</p>
<h2>如何持续产出优质创意</h2>
<p>创意不是灵光一现，而是系统化的产出流程。果冻传媒建立了"创意工坊"机制，每周组织跨团队头脑风暴，并定期邀请行业大咖进行创意分享。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Creative%20studio%20with%20art%20supplies%20and%20inspiration%20wall%20filled%20with%20colorful%20sketches%20and%20typography%20samples%2C%20warm%20natural%20light%2C%20artistic%20and%20inspiring%20workspace%2C%20soft%20warm%20tones%2C%20editorial%20photography%2C%20creative%20professional%20atmosphere%20with%20organic%20textures&width=800&height=500&seq=article-cover-05&orientation=landscape',
    author: '陈思远',
    authorTitle: '创意组长',
    publishedAt: '2026-07-10',
    readTime: '5分钟',
    tags: ['内容创意', '创意思维', '品牌表达'],
  },
  {
    id: 6,
    title: '品牌如何在抖音做好内容营销',
    slug: 'how-brands-succeed-on-tiktok-content-marketing',
    category: 'short-video',
    categoryName: '短视频制作',
    excerpt: '抖音已成为品牌营销的必争之地。果冻传媒基于服务50+品牌的经验，总结出抖音内容营销的制胜法则。',
    content: `<p>抖音已成为品牌营销的必争之地。果冻传媒基于服务50+品牌的经验，总结出抖音内容营销的制胜法则。</p>
<h2>抖音生态的底层逻辑</h2>
<p>抖音的推荐算法决定了"内容质量"是唯一的核心变量。品牌需要放下"高大上"的包袱，用真实、有趣、有用的内容赢得用户的停留和互动。</p>
<h2>品牌抖音运营四步法</h2>
<p>第一步：明确账号定位和人设；第二步：建立内容日历和选题库；第三步：持续产出和迭代优化；第四步：建立数据驱动的复盘机制。</p>
<h2>常见误区与避坑指南</h2>
<p>很多品牌犯的错误包括：内容过于硬广、忽视评论区互动、盲目追热点、缺乏长期规划。果冻传媒建议品牌以季度为单位制定内容策略，保持稳定的更新频率。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20vibrant%20social%20media%20content%20with%20modern%20studio%20backdrop%2C%20warm%20lighting%2C%20creative%20workspace%20with%20color%20swatches%20and%20planning%20calendar%2C%20contemporary%20aesthetic%2C%20soft%20warm%20tones%2C%20editorial%20product%20photography%20style&width=800&height=500&seq=article-cover-06&orientation=landscape',
    author: '张明远',
    authorTitle: '创意总监',
    publishedAt: '2026-07-05',
    readTime: '9分钟',
    tags: ['抖音营销', '短视频', '内容运营'],
  },
  {
    id: 7,
    title: '小红书品牌营销实战指南',
    slug: 'xiaohongshu-brand-marketing-practical-guide',
    category: 'social-media',
    categoryName: '社交媒体运营',
    excerpt: '小红书作为消费决策的核心平台，正成为品牌增长的新引擎。果冻传媒分享小红书营销的实战经验。',
    content: `<p>小红书作为消费决策的核心平台，正成为品牌增长的新引擎。果冻传媒分享小红书营销的实战经验。</p>
<h2>小红书用户画像与消费心理</h2>
<p>小红书的核心用户群体是25-35岁的一二线城市女性，她们具有高消费力和强决策力。品牌在小红书的传播策略需要适应这个平台的"种草"文化和信任机制。</p>
<h2>内容策略：从种草到拔草</h2>
<p>果冻传媒建议品牌采用"金字塔内容结构"：顶部是品牌官方专业内容，中部是KOL测评体验内容，底部是UGC真实用户分享。三者协同才能形成完整的内容生态。</p>
<h2>投放策略：精准触达与高效转化</h2>
<p>我们基于数据分析和A/B测试，帮助品牌优化投放策略，确保每一分预算都花在刀刃上。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Lifestyle%20photography%20flat%20lay%20with%20notebook%2C%20coffee%20cup%20and%20smartphone%20displaying%20social%20app%2C%20natural%20morning%20light%2C%20warm%20cozy%20atmosphere%2C%20modern%20minimal%20workspace%2C%20soft%20tones%20with%20marble%20and%20wooden%20textures%2C%20editorial%20photography&width=800&height=500&seq=article-cover-07&orientation=landscape',
    author: '李思涵',
    authorTitle: '运营总监',
    publishedAt: '2026-06-28',
    readTime: '7分钟',
    tags: ['小红书', '社交电商', '品牌种草'],
  },
  {
    id: 8,
    title: '品牌TVC广告的创意方法论',
    slug: 'brand-tvc-creative-methodology',
    category: 'ad-planning',
    categoryName: '广告策划',
    excerpt: '一条优秀的品牌TVC广告，是艺术与商业的完美结合。果冻传媒分享我们在TVC广告创意上的思考与方法。',
    content: `<p>一条优秀的品牌TVC广告，是艺术与商业的完美结合。果冻传媒分享我们在TVC广告创意上的思考与方法。</p>
<h2>TVC广告的独特价值</h2>
<p>在碎片化传播时代，TVC广告依然是品牌建设不可替代的载体。它能够在30秒内建立完整的品牌故事，传递深刻的情感价值。</p>
<h2>创意TVC的五要素</h2>
<p>我们总结出优秀TVC的五大要素：一个核心洞察、一个独特概念、一个情感锚点、一个视觉记忆、一个行动号召。五要素缺一不可。</p>
<h2>果冻传媒TVC作品赏析</h2>
<p>我们为多个品牌打造的品牌TVC广告，累计获得行业大奖20余项。每一支作品背后，都是长达数月的消费者研究和创意打磨。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Film%20production%20set%20with%20professional%20cinema%20camera%20and%20lighting%20equipment%2C%20creative%20director%20reviewing%20footage%20on%20monitor%2C%20warm%20cinematic%20atmosphere%2C%20behind%20the%20scenes%20photography%20style%2C%20soft%20golden%20tones%20with%20dramatic%20lighting&width=800&height=500&seq=article-cover-08&orientation=landscape',
    author: '王浩然',
    authorTitle: '策略总监',
    publishedAt: '2026-06-20',
    readTime: '8分钟',
    tags: ['TVC广告', '品牌创意', '影视制作'],
  },
  {
    id: 9,
    title: '新消费品牌从0到1的营销路径',
    slug: 'new-consumer-brand-zero-to-one-marketing-path',
    category: 'full-case',
    categoryName: '全案营销',
    excerpt: '新消费品牌如何破局？果冻传媒基于服务多个新锐品牌的经验，梳理出一条可复用的增长路径。',
    content: `<p>新消费品牌如何破局？果冻传媒基于服务多个新锐品牌的经验，梳理出一条可复用的增长路径。</p>
<h2>阶段一：品牌定位与产品打磨</h2>
<p>新品牌的第一步是找到差异化定位，明确"我是谁、我为谁、我有什么不同"。果冻传媒通过消费者调研和竞争分析，帮助品牌确立清晰的定位。</p>
<h2>阶段二：种子用户获取与验证</h2>
<p>通过精准的KOL合作和社交媒体种草，获取第一批种子用户，验证产品力与品牌定位的匹配度。</p>
<h2>阶段三：规模化增长与品牌沉淀</h2>
<p>在验证产品力之后，通过全渠道营销组合拳，实现规模化增长。同时持续进行品牌内容建设，让品牌心智深入人心。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Startup%20brand%20launch%20strategy%20meeting%20with%20growth%20chart%20and%20brand%20identity%20materials%20on%20wall%2C%20modern%20creative%20office%20with%20natural%20light%2C%20young%20diverse%20team%20collaborating%2C%20warm%20inspiring%20atmosphere%2C%20clean%20minimalist%20aesthetic%2C%20editorial%20style&width=800&height=500&seq=article-cover-09&orientation=landscape',
    author: '赵雨晴',
    authorTitle: '客户总监',
    publishedAt: '2026-06-15',
    readTime: '6分钟',
    tags: ['新消费', '品牌建设', '增长策略'],
  },
];